/*
 * สถานที่ใกล้เคียง (POI)
 *
 * ใช้ resource `Place` ตัวเดียวกับหมุดโครงการ — คนที่ดูแลหมุดได้ก็ควรดูแลสถานที่รอบ ๆ ได้
 * ไม่ต้องเพิ่ม resource ใหม่ให้ทุก role (ฝั่ง v3 ก็ตั้งเหมือนกัน)
 */
export default [
  {
    path: '/poi/lists',
    name: 'poi-list',
    component: () => import('@/views/poi/poi-list/PoiList.vue'),
    meta: {
      resource: 'Place',
      action: 'read',
    },
  },
  {
    path: '/poi/add',
    name: 'poi-create',
    component: () => import('@/views/poi/poi-form/PoiForm.vue'),
    meta: {
      resource: 'Place',
      action: 'create',
    },
  },
  {
    path: '/poi/edit/:id',
    name: 'poi-edit',
    component: () => import('@/views/poi/poi-form/PoiForm.vue'),
    meta: {
      resource: 'Place',
      action: 'update',
    },
  },
]
